import React, { Fragment, ReactNode, useCallback, useEffect, useMemo, useRef, useState } from "react"
import OopsBanner, { NoRecordsBanner } from "../OopsBanner";
import './layouts/component-layouts.css';
import "../../VagaroComponent/Controls/multilocation.scss"; //Multilocation CSS style.
import styles from './layouts/RenderStaffMemberCards.module.css';
import { utils } from "../../utils/Utils";
import { UserContext } from '../Definitions/UserContext.js'; //UseContext which have store common context data.
import { BlogIcon, FacebookIcon, InstagramIcon, LinkedinIcon, MySpaceIcon, PintrestIcon, TikTokIcon, TwitterIcon, VagaroIcon, WebsiteIcon, YelpIcon, YoutubeIcon, ThreadIcon } from "../Icons/SocialIcons";
import {  GetAdminServices, GetBuseinssesInDistanceForRenters, GetBusinessLocation, GetListingOnlyBusinesses } from "../Utilities/BusinessData";
import XIcon from "../Icons/XIcon";

import { LocationFilterDropdown } from "./RenderBusinessLocation";
import ReactDOM, { unmountComponentAtNode } from "react-dom";
import VGPopUp from "../Controls/VGPopUp";
import InputWithDropdown from "../../VagaroComponent/Controls/InputWIthDropdown";
import { useTrackingEvent } from "../../Hooks/useAddTrackingEvent";



const avatarSize = "4.5em";

export const bNameperPageSize = 15;
const bookBtnStyle:any = {position:"absolute",bottom:"-20px",padding:"8px 48px"}
const fixedProfileImage = { minWidth: "86px", minHeight: "86px", maxWidth: "86px", maxHeight: "86px" };
export type BusinessOwnerData = {
    encBID: string,
    encStaticMerchantid: string,
    bidHash: string,
    businessName: string,
    firstName: string,
    suite: string,
    lastName: string,
    spintials: string,
    photoURL: string,
    alias: string,
    businessLogo: string,
    facility:string,
    socialLinks:string,
    isDormant:boolean,
    websiteURL:string,
    telephone:string,
    countryID:number,
    nickName?:string,
    totalCount:number,
    isDisplayHomeInVagaroPlus : boolean
}

export type AdminServiceData = {
    category:string,
    service:string[],
}

let tempData:BusinessOwnerData = {
    encBID: "",
    encStaticMerchantid: "",
    bidHash: "",
    businessName: "            ",
    firstName: "First Name",
    lastName: "Last Name",
    suite:"FL",
    spintials: "",
    photoURL: "",
    businessLogo: "",
    alias: "loading",
    facility:"",
    socialLinks:"",
    isDormant:false,
    websiteURL: "",
    telephone:"",
    nickName:"loading",
    countryID:1,
    totalCount:3,
    isDisplayHomeInVagaroPlus: false
}

const DormantBusinessClickType = {
    pageView: 1,
    BookNow: 2,
    Call: 3,
};

const stencilArr = [tempData, tempData, tempData];

const getFilteredServiceCatList = (data:AdminServiceData[],text:string) => {



    let terms = text.toLowerCase().split(" ");

    let filteredData = [];

    for(let i = 0;i<data.length;i++){
        let item:{category:string,service:string[],nodes:ReactNode[]} = {category:data[i].category,service:[],nodes:[]};

        for(let e = 0;e<data[i].service.length;e++){
            let service = data[i].service[e].toLowerCase();
            let isMatch = true;
            for(let j = 0;j<terms.length;j++){
                if(!service.includes(terms[j])){
                    isMatch = false;
                    break;
                }
            }
            if(isMatch){
                if(terms.length==1){
                    let str = terms[0];
                    let index = service.indexOf(str);
                    let realCase = data[i].service[e];
                    let beforeStr = realCase.substring(0,index);
                    let bolded = realCase.substring(index,index+str.length);
                    let afterStr = realCase.substring(index+str.length,service.length);
                    item.nodes.push(<div className="inset-item"> <span>{beforeStr}<b>{bolded}</b>{afterStr}</span></div>);
                }
                else{
                    item.nodes.push(<div className="inset-item"><span>{data[i].service[e]}</span></div>)
                }
                item.service.push(data[i].service[e]);
            }
        }

        if(item.service.length>0){
            filteredData.push(item);
        }
    }

    return filteredData;

}

export default function RenderBusinessOwnerName({ data, layout, siteData, bTypes,hideServices,useLogo, splitTypes,placeholder1,placeholder2,placeholder3,enterpriseName }: {
    placeholder1?:string, placeholder2?:string, placeholder3?:string,
    useLogo:boolean, hideServices:boolean, data: any, layout: string, siteData: UserContext, bTypes:any,splitTypes?:boolean, enterpriseName?:string}) {

    const [isStenciled,setIsStenciled] = useState(data?.isStenciled === true);
    const [serviceTypeStencil,setServiceTypeStencil] =useState(false);
    const [bData,setBData] = useState<BusinessOwnerData[]>(data);
    const [bType, setbType] = useState<any[]>(bTypes);
    const [serviceBtype, setServiceBtype] = useState<any[]>(bTypes);

    const [searchText, setRootSearchText] = useState("");
    const searchTextRef = useRef<string>("");
    const setSearchText = (text:string)=>{
        searchTextRef.current = text;
        setRootSearchText(text);
    }
    const [pageLoaded, setPageLoaded] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [loadingMore, setLoadingMore] = useState(false);
    const [stencilCount,setStencilCount] = useState(0);
    const [latLon,setLatLon] = useState({lat:0,lon:0});
    const lastServiceRef = useRef<string>("");
    const [serviceData, setServiceData] = useState<AdminServiceData[]>([]);
    const [serviceText,setRootServiceText] = useState("");
    const serviceTextRef = useRef<string>("");
    const setServiceText = (text:string)=>{
        serviceTextRef.current = text;
        setRootServiceText(text);
    }

    const [nickName,setNickName] = useState(GetNickNameParams());
    const [address,setAddress] = useState("");
    const debounceRef = React.useRef<any>(undefined);

    const isLiveSearch = ()=> (!nickName || nickName.length < 2) && (!address|| address.length < 2);

    const updateSearch = (val:string,serviceVal:string ="",applyFilter:boolean = true)=>{
        console.trace("Update Search",val,serviceVal)
        if(applyFilter)
            setSearchText(val);
        //for nick name ignore pagination and just filter

        if(isLiveSearch()){


            if(debounceRef.current){
                clearTimeout(debounceRef.current);
            }
            if(val.length==0||val.length>3) {
                debounceRef.current = setTimeout(()=>{
                    setBData([]);
                    setbType([]);
                    setIsStenciled(true);
                    reSearch(val,serviceVal);

                },300)
            }

        }
    }

    useEffect(()=>{
        if(serviceTextRef.current.length==0){
            setServiceBtype([]);
        }
        else if(serviceTextRef.current.length>0&&!isLiveSearch() ){
          GetBtypeFromService(serviceTextRef.current);
        }

    },[address,nickName])

    // update everytime now that multiple values for service text and btypes is needed

    const  searchByLocation = async (lat:number,lon:number)=>{

        const renters:any = [];
        setBData([]);
        setIsStenciled(true);

        if(lat==0&&lon==0){
            return;
        }
        setIsStenciled(true);
        const dataObj:{data:null|any[]} = {data:null};

        await GetBuseinssesInDistanceForRenters(siteData,lat,lon,(data:any)=>{

            dataObj.data = data;

        },(err:any)=>{

            setIsStenciled(false);
        })

        if(dataObj.data){
            for(let i = 0;i<dataObj.data.length&&i<5;i++){
                let d = dataObj.data[i];

                if(renters.length<90)
                await GetListingOnlyBusinesses(siteData,(newData:any)=>{
                    renters.push(...newData.location);
                    setbType(newData.bType);
                },(err:any)=>{
                    setLoadingMore(false);
                    console.log(err);
                },"1","100","","",false,d.alias,bType);
            }

            setBData(renters.slice(0,120));
            setIsStenciled(false);

        }
        else{

            setIsStenciled(false);
        }
    }

    const loadMore =  () => {

        let newPage = pageLoaded + 1;
        setStencilCount(Math.min(totalItems - pageLoaded *bNameperPageSize, bNameperPageSize));
        setPageLoaded(newPage);
        setLoadingMore(true);

        GetListingOnlyBusinesses(siteData,(newData:any)=>{
            let d = bData;
            setBData([...d,...newData.location]);
            setbType(newData.bType);
            setLoadingMore(false);
        },(err:any)=>{
            setLoadingMore(false);
            console.log(err);
        },newPage.toString(),bNameperPageSize.toString(),searchTextRef.current,serviceTextRef.current,(layout==="2"),"",bType)

    }
    const reSearch = useCallback((search:string,serviceSearch:string, nickName?:string)=>{


        setBData([]);
        setbType([]);
        setPageLoaded(1);
        setIsStenciled(true);
        setLoadingMore(true);

        GetListingOnlyBusinesses(siteData,(newData:any)=>{

            var ndata = newData && newData.location;

            var nbtype = newData && newData.bType;

            if(newData && newData.location) {
                setBData(ndata);
            }
            else {
                setBData([]);
            }

            if(newData && newData.bType) {
                setbType(nbtype);
            }
            else {
                setbType([]);
            }

            setIsStenciled(false);
            setLoadingMore(false);

            if(ndata&&ndata.length>0){
                setTotalItems(ndata[0].totalCount);
                setTotalPages(Math.ceil(ndata[0].totalCount / bNameperPageSize));
            }
            else {
                setTotalItems(0);
                setTotalPages(0);
            }

        },(err:any)=>{
            setIsStenciled(false);
            setLoadingMore(false);
            console.log(err);
        },"1",bNameperPageSize.toString(),search,serviceTextRef.current, (layout==="2"),layout=="2"?nickName:"",[])

    },[data,bData,layout,nickName,serviceText,searchText])

    const GetBtypeFromService = (inServiceText:string) => {


        if(!isLiveSearch())
            setServiceTypeStencil(true);

        GetListingOnlyBusinesses(siteData,(newData:any)=>{

            var nbtype = newData && newData.bType;

            if(newData.bType) {
                setServiceBtype(nbtype);
            }
            else { // if invalid service then set to a non matching string to hide all wihtout extra logic
                setServiceBtype(["-+preventmatching@!&*?;:+-"]);
            }

           setServiceTypeStencil(false);

        },(err:any)=>{

                setServiceTypeStencil(false);
            console.log(err);
        },"1",bNameperPageSize.toString(),"",inServiceText,true,"",[])



    }


    useEffect(() => {

        if (!hideServices) {

            GetAdminServices(siteData, (data: any) => {

                setServiceData(data);

            }, (err: any) => {
                console.log(err);
            })
        }


    },[hideServices]);

    useEffect(() => {

        if(data&&data.length>0&&data[0]?.totalCount && totalItems != data[0].totalCount){
            setTotalItems(data[0].totalCount);
            setTotalPages(Math.ceil(data[0].totalCount / bNameperPageSize));
            setBData(data);
        }

        if(!data||!data.isStenciled)
            setIsStenciled(false);

    }, [data])

    useEffect(()=>{
        if(latLon.lat!=0&&latLon.lon!=0)
            searchByLocation(latLon.lat,latLon.lon);
    },[latLon])

    if (!data || data.length == 0) {
        return <NoRecordsBanner message='Owner Data is not available.' showInLive={true} />
    }

    let p1 = placeholder1&&placeholder1.length>0?placeholder1:"Name";
    let p2 = placeholder2&&placeholder2.length>0?placeholder2:"Search Services";
    let p3 = placeholder3&&placeholder3.length>0?placeholder3:"Location";

      return <>
    {(window as any).isEditor&& <style>{`.canvas .bon > *{pointer-events:none!important}`}</style>}
            <div className="w-full p-12 flex-row-to-column gap-med bon" >

                <SearchInput defaultValue={searchText} placeHolder={p1} onUpdate={(text:string)=>{ updateSearch(text,serviceTextRef.current);}} onClear={(text:string)=>{updateSearch("",serviceTextRef.current)}} />
               {!hideServices&& <ServiceInputField
                p2 = {p2}
                onFinalize={(text:string)=>{
                    if(lastServiceRef.current==text) // avoid repeat calls when just clicking in and out without changing text
                        return;

                    lastServiceRef.current = text;

                    if(!isLiveSearch()){
                        if(text.length>0){
                        GetBtypeFromService(text);
                        }
                        else{
                            setServiceBtype([]);
                        }
                    }
                    else{
                    updateSearch(searchTextRef.current,text,false);
                    }

                }}
                onSelect={(text:string)=>{}}
                serviceData={serviceData}
                searchText={serviceText}
                setSearchText={(text:string)=>{setServiceText(text); }} /> }



              {layout=="2"&&
                  <LoactionSearchInput
                  onLatLon={(lat,lon)=>{setLatLon({lat,lon})}}
                  onSelectCurrent={()=>{

                    const onError = () => {

                        window.alert("Unable to get current location. Please check your browser settings and try again.");
                    }

                    if (typeof navigator != 'undefined' && typeof navigator != null &&
                        typeof navigator.geolocation != 'undefined' && navigator.geolocation != null) {
                        if (typeof navigator.permissions != 'undefined' && navigator.permissions != null) {
                            navigator.permissions.query({ name: 'geolocation' }).then(function (result) {

                                if (result.state == 'denied') {
                                    AccessLocationMessage("Location", "Allow access to Location Services to get your current location.")

                                }
                                else{
                                    setIsStenciled(true);
                                    navigator.geolocation.getCurrentPosition((position) => {
                                        setAddress("Current Location");

                                        let lat = position.coords.latitude;
                                        let lon = position.coords.longitude;
                                        setLatLon({lat,lon});


                                    }, (error) => {
                                        onError();
                                    });
                                }

                            })
                        }
                    }
                  }}
                  userContext={siteData}
                  onSelectAddress={(str)=>{
                    setAddress(str);
                  }}
                  nickName={nickName||address} placeHolder={p3} onSelectNickname={(alias:string)=>{

                    setNickName(alias);
                    reSearch(searchTextRef.current,serviceTextRef.current,alias);
                }} onClear={()=>{

                    setNickName("");
                    setAddress("");
                    reSearch(searchTextRef.current,serviceTextRef.current,"");

                }} /> }
            </div>
            <RenderCardLayout enterpriseName={enterpriseName} splitTypes={splitTypes==true} useLogo={useLogo} filter={!isLiveSearch()? searchText:""}

            bTypeFilter={!isLiveSearch()?serviceBtype:undefined}
            data={bData} isStenciled={isStenciled || serviceTypeStencil} siteData={siteData} >

                {loadingMore &&Array.from({ length: stencilCount }).map((_, index) => {
                    return <RenderMainCard splitTypes={splitTypes==true} key={index} isStenciled={true} ownerdata={tempData} siteData={siteData} useLogo={useLogo} enterpriseName={enterpriseName} />

                })}
            </RenderCardLayout>

            {pageLoaded < totalPages && layout==="2" && (isLiveSearch())&& <div className="center-all w-full" style={{ padding: "8px" }}> <button style={{ minWidth: "200px" }} className="v-button primary load-more-button"

            onClick={loadMore}
            >Load More</button></div>}

        </>

}




function RenderCardLayout({filter, bTypeFilter, data, isStenciled, siteData,children,useLogo,splitTypes,enterpriseName }: {enterpriseName?:string, filter:string,bTypeFilter?:string[], data: any, isStenciled: boolean, siteData: UserContext ,children?:any, useLogo: boolean, splitTypes: boolean}) {
    if (data === undefined)
        return <OopsBanner />

    let filterSplit =  filter.toLowerCase().split(" ");


    if(isStenciled){

        return <div  className={"w-full flex-row flex-wrap bon "+(isStenciled?"stenciled":"")} style={{alignItems:"stretch",paddingBottom:"12px"}} >
        {stencilArr.map((ownerdata: BusinessOwnerData, index: number) => {
            return  <RenderMainCard enterpriseName={enterpriseName} splitTypes={splitTypes} key={index} isStenciled={isStenciled} ownerdata={ownerdata} siteData={siteData} useLogo={useLogo} />

            })}
    </div>


    }

    if(data.length == 0){
        return <RenderNoRecord />
    }


    let emptyCn = 0;
    return <div className={"w-full flex-row flex-wrap "+(isStenciled?"stenciled":"")} style={{alignItems:"stretch",paddingBottom:"24px"}} >
        {data && data.map&&data.map((ownerdata: BusinessOwnerData, index: number) => {


        let itemString = (filter.length>0||(bTypeFilter&&bTypeFilter.length>0) )? (ownerdata.firstName+" "+ownerdata.lastName+" "+ownerdata.businessName +" "+(ownerdata.nickName??"")+" "+ ownerdata.suite+" " + ownerdata.facility.replaceAll(","," ") ).toLowerCase():"";

        let isMatch = true;
        let anyMatch = (bTypeFilter&&bTypeFilter.length>0)?false:true;

        if(bTypeFilter&&bTypeFilter.length>0){


            for(let i = 0;i<bTypeFilter.length;i++){
                if(itemString.includes(bTypeFilter[i].toLowerCase())){
                    anyMatch = true;
                    break;
                }
            }
        }

        for(let i = 0;i<filterSplit.length;i++){
            if(!itemString.includes(filterSplit[i])){
                isMatch = false;
                break;
            }

        }



        if(!isMatch||!anyMatch){
            emptyCn = emptyCn + 1
            if(emptyCn == (index + 1) && (index + 1 == data.length)){
                return <RenderNoRecord />
            }
            return null;
        }

         return  <RenderMainCard enterpriseName={enterpriseName} splitTypes={splitTypes} useLogo={useLogo} isStenciled={isStenciled} ownerdata={ownerdata} siteData={siteData} />

})}
{children}

    </div>


}



function Redirection(alias: string, siteData: UserContext,inId?:string,isDormant?:boolean) {


    let linkDom = document.getElementById( (isDormant?"owner-click-link2":"owner-click-link"));
    let pageURL = "/.";

    if(linkDom){
        pageURL = linkDom.getAttribute("href") ?? "/.";
    }

    if((window as any).isEditor){

        if ((window as any).isEditor) {
            let windowObj = window as any;
            if (windowObj.OpenPreviewLocation) {
                windowObj.OpenPreviewLocation(inId, pageURL)
            }
            return;
        }
        return

    }
    if (window.location.origin == utils.MySiteName()) {
        var url = window.location.origin;
        url = url + "/" + siteData.vgurl + "/" + alias+"/"+pageURL;
        window.open(url, "_self");
    }
    else {
        var url = window.location.origin;
        url = url + "/" + alias +"/"+pageURL;
        window.open(url, "_self");
    }
}

function RedirectionURL(url: string) {
    if(url.length > 0) {
        let a = document.createElement("a");
        a.target = "_blank";
        a.href = url
        a.click();
    }
}

function GetSocialLinks(socialLinks:string){

    try{
        return JSON.parse(socialLinks);
    }

    catch(e){

        return undefined;
    }
}

function RenderNoRecord() {
   return <><br/><NoRecordsBanner message='No Results Found' showInLive={true} /><div style={{height:"300px"}}></div></>
}

function RenderMainCard({ ownerdata, isStenciled, siteData, useLogo, splitTypes, enterpriseName }: { ownerdata: BusinessOwnerData, isStenciled: boolean, siteData: UserContext, useLogo: boolean,splitTypes:boolean,enterpriseName?:string }) {
    const socials = GetSocialLinks(ownerdata.socialLinks);
    const [ TrackEvent ] = useTrackingEvent();
    let isDormant = (ownerdata?.isDormant === true);
    let url = ownerdata?.websiteURL??"";
    let tele = ownerdata?.telephone??"";
    let showBook = !isDormant || url.length > 0;
    let MerchantID = ownerdata?.encStaticMerchantid ?? "QX9p3jq6~mMP6js9ReeSqw==";
    let ParentMerchantID = siteData.parentbid || "QX9p3jq6~mMP6js9ReeSqw==";
    let Reffrer = window.location.pathname.split("/").find(val => val !== "") || "";
    let UserID = "VjyaDUqIaJ9ZTvKEP9kn6g==";
    let LoginDetails = utils.ReadCookie();
    let LoginUserID = LoginDetails.csEncUid;
    if (typeof LoginUserID != "undefined" && LoginUserID != null && LoginUserID != "") {
         UserID = LoginUserID;
    }

    let suite = ownerdata.suite;

    switch (enterpriseName) {
        case "sola":
            if (suite && suite.length > 0) {

                //get the last number from line 2.
                let nums = suite.replace(/[^0-9]/g, ' ').split(' ').filter(n => n !== '');

                if (nums.length > 0) {
                    suite = "Studio " + nums.pop() + " at Sola Salons " + ownerdata.nickName;
                }
                else{
                    suite = "";
                }
            }
            break;

        default:

            if (ownerdata.suite) {
                let str = ownerdata.suite;
                if (!isNaN(Number(str)) && !isNaN(parseFloat(str))) {
                   suite = "SUITE# " + str;
                }
            }
            break;


    }
    let facility = ownerdata.facility;
    let fSplit:string[] = [];
    if(facility.length>0 && splitTypes){
        fSplit = facility.split(",").filter((val)=>val.length>0);
    }


    if(url.length > 0) {
        if(!url.includes("http")){
            if(!url.includes("www.")){
                url = "www."+url;
            }
            url = "https://"+url;
        }
    }

    let imgURL = (useLogo) ? ownerdata.businessLogo : ownerdata.photoURL;

    return <div className={"b-list-wrapper p-12 third-half-full "+(isStenciled?"stenciled":"")} style={{paddingBottom:"30px"}} >
        <div className="business-list-card relative w-full h-full flex-column "
            style={{ cursor: "pointer" }}
            onClick={(e) => {
                if (!isStenciled) {

                    if (ownerdata.isDormant) {
                        sessionStorage.setItem("owner-external-url", url);
                    }
                    StoreRenterImage(ownerdata);
                    if ((e.target as HTMLElement).tagName === 'BUTTON' && (ownerdata.isDormant === true || ownerdata.isDisplayHomeInVagaroPlus === true) ) {
                        TrackEvent(
                            ParentMerchantID,
                            MerchantID,
                            UserID,
                            DormantBusinessClickType.BookNow,
                            window.location.origin + "/" + Reffrer,
                            ownerdata.businessName,
                            () => {
                                Redirection(ownerdata.alias, siteData, ownerdata.encBID, ownerdata.isDormant)
                            }
                        );
                    } else {
                        Redirection(ownerdata.alias, siteData, ownerdata.encBID, ownerdata.isDormant)
                    }
                }
            }}
        >
        <div className="b-list-content h-full w-full  p-16 flex-column align-center col-gap-large" style={{padding:"20px 20px 10px"}}>

            {imgURL?
            <div className="business-profile-image stencil-item covered-bg  staff-image-border" style={{backgroundImage:`url(${imgURL})`,marginLeft:"2px",marginRight:"2px",...fixedProfileImage}} > </div>:
            <div className="business-profile-image stencil-item covered-bg  staff-image-border relative staff-initials" style={{marginLeft:"2px",marginRight:"2px",...fixedProfileImage}} >
                    <div className="center-all w-full h-full" style={{position:"absolute",left:"0",top:"0",fontSize:"2em"}} >
                        {ownerdata.spintials}
                    </div>
             </div>

            }
            <div className="business-profile-text h-full flex-column  align-center" style={{padding:"0 12px"}} >
                <div className="name-column flex-column" style={{alignItems:"inherit",justifyContent:"inherit"}}>
                <h2  style={{fontSize:"1.15em",fontWeight:"bold",color:"inherit"}}>{ownerdata.businessName}</h2>
                <div className="stencil-item renter-name" style={{fontSize:"1.15em"}}>{ownerdata.firstName} {ownerdata.lastName}</div>
                </div>
                {ownerdata.nickName&&<div className="stencil-item renter-nick-name">{ownerdata.nickName}</div>}
                {suite&&
                    <div className="stencil-item font-bold suite" style={{paddingTop:"6px"}} >{suite}
                    </div>
                }
            </div>

         </div>
        <div className="book-row  w-full flex-column center-all gap-med no-shrink" style={{minHeight:"98px",padding:"6px 12px 28px"}}>
                {ownerdata.facility && !splitTypes && <>

                    <div className="business-types-row text-align-center">
                        {ownerdata.facility}

                    </div></>
                }
                {splitTypes && fSplit.length > 0 &&
                    <div className="business-types-row text-align-center flex-row center-all flex-wrap " style={{ justifyContent: "center", paddingBottom: "6px" }}>
                        {fSplit.map((val, index) => <div key={index} className="business-type-item" >{val}</div>)}
                    </div>
                }


           {(socials||tele.length>0) &&

            <div className={"contact-row center-all w-full  font-large inherit-color flex-wrap " +(!showBook&&!ownerdata.facility?"center-socials":"")}  style={{margin:"4px",gap:"12px"}}>

                  {tele.length>0&& //call and message icons (not functional currently)
                    <>
                        <a
                            className="no-a center-all call-or-text social-icon"
                            onClick={(e) => {
                                e.stopPropagation();
                                if (ownerdata.isDormant === true || ownerdata.isDisplayHomeInVagaroPlus === true) {
                                    TrackEvent(
                                        ParentMerchantID,
                                        MerchantID,
                                        UserID,
                                        DormantBusinessClickType.Call,
                                        window.location.origin + "/" + Reffrer,
                                        ownerdata.businessName,
                                        () => { }
                                    );
                                }
                            }}
                            style={{ padding: "4px" }}
                            href={`tel:${tele}`}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" viewBox="0 0 512 512"> <path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z" /></svg>
                        </a>
                    </>
                }
                {socials&&socials.length>0&&
                    socials.map((social:{SocialTitle:string,SocialLink:string},index:number)=>{

                        return <RenderSocialIcon key={social.SocialTitle} type={social.SocialTitle} link={social.SocialLink}/>
                    })
                }
                {url && <RenderSocialIcon type="website" link={url}/>}



             </div>
        }
        {!isDormant && // active account
            <button style={bookBtnStyle} className="v-button primary stencil-item">Book Now</button>
        }
        {isDormant && url.length>0 && // dormant account that has an external link



            <a
                style={bookBtnStyle}
                className="v-button primary stencil-item no-a dormant-link center-all"
                onClick={(e) => {
                    StoreRenterImage(ownerdata);
                    e.stopPropagation();
                    if (isDormant === true) {
                        TrackEvent(
                            ParentMerchantID,
                            MerchantID,
                            UserID,
                            DormantBusinessClickType.BookNow,
                            window.location.origin + "/" + Reffrer,
                            ownerdata.businessName,
                            () => {
                                RedirectionURL(url)
                            }
                        )
                    } else {
                        RedirectionURL(url)
                    }
                }}
            >Book Now &nbsp;
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" viewBox="0 0 512 512"><path d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l82.7 0L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3l0 82.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L320 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z"/></svg>
            </a>

        }
        </div>
    </div>
    </div>

}

function ServiceInputField({serviceData,searchText,setSearchText,onSelect,onFinalize,p2}:{p2:string,onFinalize:(text:string)=>void, searchText:string,setSearchText:(text:string)=>void, serviceData:AdminServiceData[],onSelect:(text:string)=>void}){

    // const [searchText,setSearchText] = useState("");
    //

    const filtered = getFilteredServiceCatList(serviceData,searchText);
    const options  = [];
    for(let i = 0;i<filtered.length;i++){
        options.push({content:<b>{filtered[i].category}</b>,id:filtered[i].category,isHeading:true});
        for(let j = 0;j<filtered[i].service.length;j++){
            options.push({content:filtered[i].nodes[j],id:filtered[i].service[j],isHeading:false});
        }
    }

    return <InputWithDropdown clsName="service-search-feild" loading ={serviceData.length<=0}

    onClear = {()=>{setSearchText("");onSelect("")}}

    onSelect={(id:string,data:any) => {
        setSearchText(id);

        onSelect(id);
     } } onChange={(text:string) => {setSearchText(text);} } onFinalize={(text:string)=>{setSearchText(text); onFinalize(text);  }}  defaultValue={searchText} placeHolder={p2}  options={options}  />

}

function SearchInput( {defaultValue,placeHolder,onUpdate,onClear}:{defaultValue:string,placeHolder:string, onUpdate:(val:string)=>void, onClear:(val:string)=>void}  ){

    return <div className={"relative w-full ownn-search search-input "+(defaultValue.length<=0?"empty":"")} style={{fontSize:"16px"}}>

        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" fill="#333" style={{ position: "absolute", left: "8px", top: "16px", pointerEvents: "none" }}><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" /></svg>

        <input value={defaultValue} defaultValue={defaultValue} maxLength={100} className="w-full" type="text" style={{ padding:"10px 8px 10px 28px",borderRadius:"4px",border:"1px solid #c7c7c7",outline:"none"}} placeholder={placeHolder}
        onInput={(e)=>onUpdate((e.target as HTMLInputElement).value)}
        />

      {defaultValue.length > 0 &&
        <div  style={{left:"inherit", position:"absolute", right:"8px", top:"10px", zIndex:5}} onClick={() => onClear("")}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
            </svg>
        </div>
        }

    </div>

}

const AccessLocationMessage = (title: string, body: string) => {
    const PopupClose = () => {
        let dom = document.getElementById("OpenDialog");
        if (dom) unmountComponentAtNode(dom);

    };

    return ReactDOM.render(
        <VGPopUp
            id={"Alert"}
            show={true}
            onHide={PopupClose}
            title={title}
            dialogClassName="vgn-popup vgn-modal-alert vgn-modal-small"
            body={<div>
                {body}
            </div>}
            footer={<Fragment>
                <button className="v-button secondary invisible-button w-25" onClick={() => PopupClose()}>Close</button>
            </Fragment >}
            isRemoveTabModalIndex={false}
            isShowFooter={true}
            backdrop={true}
        />,
        document.getElementById("OpenDialog")
    );
}

function LoactionSearchInput({ userContext, placeHolder, nickName, onClear,onSelectNickname,onSelectAddress,onSelectCurrent,onLatLon }: {onLatLon:(lat:number,lon:number)=>void, nickName?: string, userContext: UserContext, placeHolder: string, onSelectNickname: (val: string) => void,onSelectAddress:(val:string)=>void, onClear: () => void,onSelectCurrent:()=>void }) {


    //const [results, setResults] = useState<any[]>([]);
    // const [loading, setLoading] = useState(false);
    // const [locationOptions, setLocationOptions] = useState<any[]>([]);
    const [search, setSearch] = useState("");
    const [bData, setBData] = useState<any[]>([]);
    const [isLoading,setIsLoading] = useState(true);
    // const [searchLoading, setSearchLoading] = useState(false);
    const [focused, setFocused] = useState(false);
    const ref = React.useRef<HTMLDivElement>(null);
    const inputRef = React.useRef<HTMLInputElement>(null);
    const onClickOutse = useCallback(
        (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                setFocused(false);
            }
        }
        , [])



    useEffect(() => {
        GetBusinessLocation(userContext, true, (data: any) => {

            setIsLoading(false);
            setBData(data.map((data: any) => {

                data.all = data.businessName + " " + data.street + " " + data.streetNo + " " + data.city + " " + data.stateCode + " " + data.stateName + " " + data.zip + " " + data.distance + " " + data.alias + " " + data.nickName
                return data;

            }));
        }, (err: any) => {
            console.log(err);
            setIsLoading(false);
        })

    }, [])

    const updateSearch = (val: string) => {

        setSearch(val);

    };

    useEffect(() => {

        document.addEventListener("click", onClickOutse);
        return () => {
            document.removeEventListener("click", onClickOutse);
        }


    }, [])

    return <div className={"relative w-full search-location-input "+(search.length<=0?"empty":"")} ref={ref} style={{ fontSize: "16px" }}>
        {(!nickName||nickName.length==0) &&
            <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" fill="#333" style={{ position: "absolute", left: "8px", top: "16px", pointerEvents: "none" }}><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" /></svg>
        }
        <input ref={inputRef} disabled={nickName != undefined && nickName.length > 0} onFocus={() => setFocused(true)}  maxLength={100} className="w-full" type="text" style={{ padding: "10px 8px 10px 28px", borderRadius: "4px", border: "1px solid #c7c7c7", outline: "none" }} placeholder={placeHolder}
            onInput={(e) => updateSearch((e.target as HTMLInputElement).value)}
        />

        {nickName &&
            <div className="flex-row justify-between v-button primary nickname-button" style={{cursor:"default", position: "absolute",top:"6px",left:"6px",height:"calc(100% - 12px)",padding:"8px 8px 8px 12px",gap:"8px" }}>
                <div>{nickName}</div>
                <div className="center-all" style={{ cursor:"pointer" }}
                    onClick={() => {
                        setFocused(false);
                        onClear();
                        setSearch("");
                        if(inputRef.current)
                            inputRef.current.value = "";
                    }}
                ><XIcon /></div>
            </div>

        }

        {( focused) &&
        <LocationFilterDropdown
        reversed={true}
        setProcessing={(val: boolean) => { } }
        onSelectBusiness={(item) => { onSelectNickname(item.alias); setFocused(false);  } }
        input={search}

        businessList={bData}
        userContext={userContext}
        onSelect={(a) => { onSelectAddress(a);  setFocused(false); } }
        onSelectCurrent={() => {



            onSelectCurrent();
            setFocused(false);


        } }
        isLoading={isLoading}
        setLatLon={(lat, long) => { onLatLon(lat,long) } }
        setplace_id={undefined} place_id={""}/>

        }

    </div>

}

function RenderSocialIcon({ type, link }: { type: string, link: string }) {

    let node = <></>;

    if (link.length > 0) {
        if (!link.includes("http")) {
            if (!link.includes("www.")) {
                link = "www." + link;
            }
            link = "https://" + link;
        }
    }

    switch (type.toLowerCase()) {

        case "facebook":
            node = <FacebookIcon />
            break;
        case "twitter":
            node = <TwitterIcon />
            break;
        case "instagram":
            node = <InstagramIcon />
            break;
        case "linkedin":
            node = <LinkedinIcon />
            break;
        case "youtube":
            node = <YoutubeIcon />
            break;
        case "tiktok":
            node = <TikTokIcon />
            break;
        case "pinterest":
            node = <PintrestIcon />
            break;
        case "myspace":
            node = <MySpaceIcon />
            break;
        case "vagaro":
            node = <VagaroIcon />
            break;
        case "blog":
            node = <BlogIcon />
            break;
        case "yelp":
            node = <YelpIcon />
            break;
        case "youtube":
            node = <YoutubeIcon />
            break;
        case "website":
            node = <WebsiteIcon />
            break;
        case "thread":
            node = <ThreadIcon />
            break;

    }

    if (!node)
        return null;

    return <a onClick={(e) => { e.stopPropagation(); }} className="center-all max-100 social-icon" target="_blank" href={link} style={{ color: "inherit" }} >{node}</a>


}

export function GetNickNameParams() {

    let params = new URLSearchParams(window.location.search);
    let nickName = params.get("locationName") ?? "";

    if (nickName.length > 0)
        return decodeURI(nickName);
    else {

        let isDuplicateDom = document.getElementById("vwdplic");
        let isMysiteDom = document.getElementById("vwbisms");
        if (isDuplicateDom && (isDuplicateDom as any).value == "true"&&isMysiteDom) {

            let url = window.location.pathname.split("/").filter((item: string) => item.length > 0);
            //if it's a mysite url get the 2nd elelement (index 1) otherwise get the 1st (index 0)
            let location =((isMysiteDom as any).value !="true")? url[0]??"":url[1]??"";

            if(location)
                return decodeURIComponent(location);
        }

    }

    return "";
}


const renterImageKey = "renter-image";
const renterSplitKey = "|||";

function StoreRenterImage(data:BusinessOwnerData){

    sessionStorage.setItem(renterImageKey,(data?.alias??"")+renterSplitKey+(data?.photoURL??""));

}

export function GetStoredRenterImage(){
    let parsedURL = decodeURI(window.location.pathname);
    let item = sessionStorage.getItem(renterImageKey);

    if(item){
        let split = item.split(renterSplitKey);
        if(split.length>1){
            let path = split[0];
            let url = split[1];
            if(parsedURL.includes(path)){
                return url;
            }
        }
    }

    return "";

}